import Vue from 'vue'

const globalEventEmitter = new Vue()

export function useEventBus(): Vue {
  return globalEventEmitter
}
